import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
//---------------------------------------------------------------------
import Resize from "src/components/common/resize";
import { useMyStore } from "src/components/main/mainStore";
import {
    appTitle,
    myAxios, MyDate, MyFormData
} from "src/components/common/functions";
import Settings from "./settings";
import DataTableForm from "./dataTableForm";
//---------------------------------------------------------------------
export default function WorkOut({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    //---------------------------------------------------------------------
    const history = useHistory();
    const id = history.location.pathname.split("/")[2];
    //---------------------------------------------------------------------
    const [rawData, setRawData] = useState({});
    const [showLoading, setShowLoading] = useState(true);
    const [workOuts, setWorkOuts] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [showDataTable, setShowDataTable] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [workOutDate, setWorkOutDate] = useState(id);
    //---------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            if(
                history.action === "REPLACE" && (history.location.state === undefined || history.location.state.external !== true) /* `internal history.replace`, not from log in */
            ) return;
            const id = history.location.pathname.split("/")[2];
            let curDate = "";
            if(id && id.match(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/)){
                curDate = id;
            }else{
                setWorkOutDate("");
                history.replace("/WorkOut");
                return; // no day name called "", but if save all data at begin, then should remove return
            }
            const formData = new MyFormData();
            formData.append("fileId", user.workOutId);
            //----------------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("common/getJSONData.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //----------------------------------------------------------
            if(res.data === ""){
                setWorkOuts([]);
                setRawData({settings: []});
            }else{
                setRawData(res.data);
                if(curDate && curDate in res.data){
                    setWorkOuts(res.data[curDate]);
                }else{
                    setWorkOuts([]);
                }
            }
        }
        getData();
        return () => isMounted = false
    }, [workOutDate, history])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //---------------------------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Work Out abvad
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "date" className = "mb-0">Date:</label>
                    <input
                        id = "date"
                        type = "date"
                        min = "1900-01-01"
                        max = {(new MyDate()).s() || "2999-12-31"}
                        className = "form-control w-auto ml-2"
                        value = {workOutDate}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            setEditMode(false);
                            setWorkOutDate(value)
                            history.push(`/WorkOut/${value}`);
                        }}
                    />
                </span>
                <span className = "pointer" onClick = {() => setShowDataTable(true)}>
                    Data Table
                </span>
                <span className = "pointer" onClick = {() => setShowSettings(true)}>
                    Settings
                </span>
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading</div>:
                !workOutDate?<div className = "cssLoading">Select date first.</div>:
                <div>
                    {workOuts.map((workOut, workOutIndex) => 
                    <div key = {workOutIndex} className = {`${workOutIndex?`my-2`:`mb-2`} p-2 border rounded`}>
                        <div className = "cssSeperateWhenWide align-items-center">
                            <label htmlFor = {`Work Out ${workOutIndex}`} className = "font-weight-bold mb-0 ml-2">Work Out {workOutIndex + 1} Name:</label>
                            {editMode?
                            <select id = {`Work Out ${workOutIndex}`} required className = "form-control w-auto ml-2" value = {workOut.hashKey} onChange = {e => {
                                setWorkOuts([
                                    ...workOuts.slice(0, workOutIndex), 
                                    {...workOut, hashKey: e.currentTarget.value},
                                    ...workOuts.slice(workOutIndex + 1)
                                ]);
                            }}>
                                <option value = "">Select</option>
                                {rawData.settings.map((setting, settingIndex) => <option key = {settingIndex} value = {setting.hashKey}>{setting.name}</option>)}
                            </select>
                            :
                            <div className = "ml-2">
                                {rawData.settings.find(setting => setting.hashKey === workOut.hashKey).name}
                            </div>
                            }
                            {workOut.hashKey?
                            <>
                            <div className = "font-weight-bold ml-2">Mode:</div>
                            <div className = "ml-2">
                                {workOut.hashKey?rawData.settings.find(
                                    setting => setting.hashKey === workOut.hashKey
                                ).mode:null}
                            </div>
                            </>
                            :<></>}
                        </div>
                        {workOut.hashKey?
                        <div>
                            {workOut.sets.map((set, setIndex) => 
                            <div key = {setIndex} className = "cssSeperateWhenWide align-items-center border rounded p-2 my-2">
                                {rawData.settings.find(setting => setting.hashKey === workOut.hashKey).mode === "Repetition"?
                                <>
                                <span className = "cssSeperateWhenWide align-items-center pl-2">
                                    <label htmlFor = {`weight ${workOutIndex} ${setIndex}`} className = "font-weight-bold mb-0 mr-2">Weight:</label>
                                    {editMode?
                                    <input
                                        id = {`weight ${workOutIndex} ${setIndex}`}
                                        className = "form-control w-auto mr-2"
                                        min = "0"
                                        step = {0.1}
                                        required
                                        type = "number"
                                        value = {set.weight || ""}
                                        onChange = {e => {
                                            let rawText = e.currentTarget.value;
                                            while(rawText !== "0" && rawText.charAt(0) === "0"){
                                                rawText = rawText.slice(1);
                                            }
                                            setWorkOuts([
                                                ...workOuts.slice(0, workOutIndex), 
                                                {...workOut, sets: [
                                                    ...workOut.sets.slice(0, setIndex), 
                                                    {...set, weight: rawText}, 
                                                    ...workOut.sets.slice(setIndex + 1)
                                                ]
                                            },
                                            ...workOuts.slice(workOutIndex + 1)
                                            ]);
                                        }}
                                    />
                                    :
                                    <span className = "mr-2">{set.weight || ""}</span>
                                    }
                                </span>
                                <span className = "cssSeperateWhenWide align-items-center pl-2">
                                    <label htmlFor = {`unit ${workOutIndex} ${setIndex}`} className = "font-weight-bold mb-0 mr-2">Unit:</label>
                                    {editMode?
                                    <select
                                        id = {`unit ${workOutIndex} ${setIndex}`}
                                        required
                                        className = "form-control w-auto mr-2"
                                        type = "text"
                                        value = {set.unit || ""}
                                        onChange = {e => {
                                            setWorkOuts([
                                                ...workOuts.slice(0, workOutIndex), 
                                                {...workOut, sets: [
                                                    ...workOut.sets.slice(0, setIndex), 
                                                    {...set, unit: e.currentTarget.value}, 
                                                    ...workOut.sets.slice(setIndex + 1)
                                                ]
                                            },
                                            ...workOuts.slice(workOutIndex + 1)
                                            ]);
                                        }}
                                    >
                                        <option value = "">Select</option>
                                        <option>LBS</option>
                                        <option>KGS</option>
                                    </select>
                                    :
                                    <span className = "mr-3">{set.unit || ""}</span>
                                    }
                                </span>
                                <span className = "cssSeperateWhenWide align-items-center pl-2">
                                    <label htmlFor = {`reps ${workOutIndex} ${setIndex}`} className = "font-weight-bold mb-0 mr-2">Reps:</label>
                                    {editMode?
                                    <input
                                        id = {`reps ${workOutIndex} ${setIndex}`}
                                        min = "0"
                                        required
                                        className = "form-control w-auto mr-2"
                                        type = "number"
                                        value = {set.reps || ""}
                                        onChange = {e => {
                                            let rawText = e.currentTarget.value;
                                            while(rawText !== "0" && rawText.charAt(0) === "0"){
                                                rawText = rawText.slice(1);
                                            }
                                            setWorkOuts([
                                                ...workOuts.slice(0, workOutIndex), 
                                                {...workOut, sets: [
                                                    ...workOut.sets.slice(0, setIndex), 
                                                    {...set, reps: rawText}, 
                                                    ...workOut.sets.slice(setIndex + 1)
                                                ]
                                            },
                                            ...workOuts.slice(workOutIndex + 1)
                                            ]);
                                        }}
                                    />:
                                    <span className = "mr-2">{set.reps || ""}</span>
                                    }
                                </span>
                                </>
                                :
                                <>
                                <span className = "cssSeperateWhenWide align-items-center pl-2">
                                    <label htmlFor = {`hours ${workOutIndex} ${setIndex}`} className = "font-weight-bold mb-0 mr-2">Hours:</label>
                                    {editMode?
                                    <input
                                        id = {`hours ${workOutIndex} ${setIndex}`}
                                        min = "0"
                                        required
                                        className = "form-control w-auto mr-2"
                                        type = "number"
                                        value = {set.hours || ""}
                                        onChange = {e => {
                                            let rawText = e.currentTarget.value;
                                            while(rawText !== "0" && rawText.charAt(0) === "0"){
                                                rawText = rawText.slice(1);
                                            }
                                            setWorkOuts([
                                                ...workOuts.slice(0, workOutIndex), 
                                                {...workOut, sets: [
                                                    ...workOut.sets.slice(0, setIndex), 
                                                    {...set, hours: rawText}, 
                                                    ...workOut.sets.slice(setIndex + 1)
                                                ]
                                            },
                                            ...workOuts.slice(workOutIndex + 1)
                                            ]);
                                        }}
                                    />
                                    :
                                    <span className = "mr-3">{set.hours || ""}</span>
                                    }
                                </span>
                                <span className = "cssSeperateWhenWide align-items-center pl-2">
                                    <label htmlFor = {`minutes ${workOutIndex} ${setIndex}`} className = "font-weight-bold mb-0 mr-2">Minutes:</label>
                                    {editMode?
                                    <input
                                        id = {`minutes ${workOutIndex} ${setIndex}`}
                                        min = "0"
                                        max = "59"
                                        required
                                        className = "form-control w-auto mr-2"
                                        type = "number"
                                        value = {set.minutes || ""}
                                        onChange = {e => {
                                            let rawText = e.currentTarget.value;
                                            while(rawText !== "0" && rawText.charAt(0) === "0"){
                                                rawText = rawText.slice(1);
                                            }
                                            setWorkOuts([
                                                ...workOuts.slice(0, workOutIndex), 
                                                {...workOut, sets: [
                                                    ...workOut.sets.slice(0, setIndex), 
                                                    {...set, minutes: rawText}, 
                                                    ...workOut.sets.slice(setIndex + 1)
                                                ]
                                            },
                                            ...workOuts.slice(workOutIndex + 1)
                                            ]);
                                        }}
                                    />
                                    :
                                    <span className = "mr-3">{set.minutes || ""}</span>
                                    }
                                </span>
                                <span className = "cssSeperateWhenWide align-items-center pl-2">
                                    <label htmlFor = {`seconds ${workOutIndex} ${setIndex}`} className = "font-weight-bold mb-0 mr-2">Seconds:</label>
                                    {editMode?
                                    <input
                                        id = {`seconds ${workOutIndex} ${setIndex}`}
                                        min = "0"
                                        max = "59"
                                        required
                                        className = "form-control w-auto mr-2"
                                        type = "number"
                                        value = {set.seconds || ""}
                                        onChange = {e => {
                                            let rawText = e.currentTarget.value;
                                            while(rawText !== "0" && rawText.charAt(0) === "0"){
                                                rawText = rawText.slice(1);
                                            }
                                            setWorkOuts([
                                                ...workOuts.slice(0, workOutIndex), 
                                                {...workOut, sets: [
                                                    ...workOut.sets.slice(0, setIndex), 
                                                    {...set, seconds: rawText}, 
                                                    ...workOut.sets.slice(setIndex + 1)
                                                ]
                                            },
                                            ...workOuts.slice(workOutIndex + 1)
                                            ]);
                                        }}
                                    />
                                    :
                                    <span className = "mr-3">{set.seconds || ""}</span>
                                    }
                                </span>
                                </>
                                }
                                {editMode?
                                <span className = "btn btn-danger px-2" onClick = {() => {
                                    if(!window.confirm("Are you sure to delete this set?")) return;
                                    setWorkOuts([
                                        ...workOuts.slice(0, workOutIndex), 
                                        {...workOut, sets: [
                                            ...workOut.sets.slice(0, setIndex),
                                            ...workOut.sets.slice(setIndex + 1)
                                        ]
                                        },
                                        ...workOuts.slice(workOutIndex + 1)
                                    ])
                                }}>Delete Set</span>
                                :null}
                            </div>)}
                        </div>
                        :null}
                        {editMode?<>
                        {workOut.hashKey?
                        <div className = "mt-2">
                            <span className = "btn btn-primary" onClick = {() => {
                                setWorkOuts([
                                    ...workOuts.slice(0, workOutIndex), 
                                    {...workOut, sets: [...workOut.sets, workOut.sets.length?
                                        {
                                            ...workOut.sets[workOut.sets.length - 1]
                                        }:{}
                                    ]},
                                    ...workOuts.slice(workOutIndex + 1)
                                ]);
                            }}>Add Set</span>
                        </div>
                        :null}
                        <div className = "mt-2">
                            <span className = "btn btn-danger" onClick = {() => {
                                if(!window.confirm("Are you sure to delete this work out?")) return;
                                setWorkOuts([
                                    ...workOuts.slice(0, workOutIndex),
                                    ...workOuts.slice(workOutIndex + 1)
                                ])
                            }}>Delete This Work Out</span>
                        </div>
                        </>
                        :null}
                    </div>)}
                    {editMode?
                    <div>
                        <span
                            className = "btn btn-info mb-2"
                            onClick = {() => {
                                setWorkOuts([
                                    ...workOuts, 
                                    {sets:[], hashKey: ""}
                                ])
                            }}
                        >
                            Add Work Out
                        </span>
                    </div>
                    :null}
                    <div>
                        {editMode?
                        <span className = "btn btn-success" onClick = {async () => {
                                const formData = new MyFormData();
                                formData.append("data", JSON.stringify({...rawData, [workOutDate]: workOuts}));
                                //----------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("workOuts/updateWorkOut.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //----------------------------------------------------------
                                user.workOutId = res.data;
                                setRawData({...rawData, [workOutDate]: workOuts});
                                setEditMode(false)
                        }}>Save</span>
                        :
                        <span className = "btn btn-primary" onClick = {() => setEditMode(true)}>
                            {workOuts.length === 0?"Create":"Edit"}
                        </span>
                        }
                        {workOuts.length === 0?
                        <></>
                        :
                        <>
                        {JSON.stringify(rawData[id]) === JSON.stringify(workOuts)?
                        <span className = "text-success font-weight-bold ml-2">Saved</span>
                        :
                        <span className = "text-danger font-weight-bold ml-2">Not Saved</span>
                        }
                        </>
                        }
                    </div>
                </div>}
            </div>
            {showSettings?
            <Settings
                keyword = "Settings" 
                closeIt = {() => setShowSettings(false)}
                id = {id} 
                rawData = {rawData} 
                setRawData = {setRawData} 
                setWorkOuts = {setWorkOuts}  
            />
            :null}
            {showDataTable?
            <DataTableForm
                keyword = "Data Table" 
                closeIt = {() => setShowDataTable(false)}
                rawData = {rawData}  
            />
            :null}
        </div>
    )
}
// piNjNwa7YRvWk304BQ7QqbgAXN81HNEp1Xkm0KyVLJ3Eok3G4hR4PpgnB4bPz1hoh
// ssh-rsa AAAAB3NzaC1yc2EAAAABIwAAAQEAvjnnZk0ELanWjezHTMN9cDGFZuSuxQgZiXpwz7OFc650ApfxgLHsJWm3GFJ4JlgMit37Lvbb7K98MIu7eZFro6YEU62bDbUa5ppucbhp52nc75QuK6Nd7LUOeQ3gAyQhwF2wsHo1HhTWdxS+CMMiMIu5CmkM9G7jYbj6O4uOzP8nIRO6U5+FcdAqdqT68CQwn+dD8GLxi11tdztTn45RqjUuNF9FqD/Zua58kfbrZi2I/NhOQSLm2WxbUp1qNEZgk1S1LVWBAXe453LUE/STzTzHQ0bla6QGVm0Uc3rhOycKs4B6b8FEgV6KuD1JHLJAhEhwd0JUKhOYWKV1x12clQ==